import { useAuthSessionQuery } from "../../utils/useAuthSessionQuery";
import { Navigate, Outlet } from "react-router";
export default function PrivateRoute() {
  const { data } = useAuthSessionQuery();

  if (data?.isAuthenticated) {
    return <Outlet />;
  }

  return <Navigate to="/login" />;
}
